
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-white rounded-t-3xl">
      <div className="max-w-[1440px] mx-auto px-8 py-16">
        <div className="grid grid-cols-12 gap-12 mb-12">
          {/* 订阅区 */}
          <div className="col-span-6">
            <h2 className="text-5xl font-light mb-4">获取1039最新政策</h2>
            <p className="text-neutral-200 text-base mb-6">
              订阅我们的资讯，第一时间了解市场采购贸易政策动态
            </p>
            <div className="flex items-center gap-4">
              <input
                type="email"
                placeholder="您的邮箱"
                className="flex-1 bg-transparent border-b-2 border-white/30 py-3 px-2 text-white placeholder-neutral-400 focus:outline-none focus:border-accent transition-colors"
              />
              <button className="px-8 py-3 bg-white text-black font-semibold rounded-full whitespace-nowrap hover:bg-accent hover:text-primary transition-all duration-300 flex items-center gap-2 cursor-pointer">
                订阅
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          {/* 快速链接 */}
          <div className="col-span-3">
            <h3 className="text-sm font-semibold mb-6 text-white/80">快速导航</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/policy" className="text-white hover:text-accent transition-colors underline cursor-pointer">
                  政策解读
                </Link>
              </li>
              <li>
                <Link to="/test" className="text-white hover:text-accent transition-colors underline cursor-pointer">
                  开始测试
                </Link>
              </li>
              <li>
                <a href="#system" className="text-white hover:text-accent transition-colors underline cursor-pointer">
                  系统演示
                </a>
              </li>
              <li>
                <a href="#about" className="text-white hover:text-accent transition-colors underline cursor-pointer">
                  入驻指引
                </a>
              </li>
            </ul>
          </div>

          {/* 联系方式 */}
          <div className="col-span-3">
            <h3 className="text-sm font-semibold mb-6 text-white/80">联系我们</h3>
            <div className="space-y-4">
              <div>
                <p className="text-2xl font-bold text-white mb-2">400-888-1039</p>
                <a href="mailto:service@1039.com" className="text-white hover:text-accent transition-colors underline">
                  service@1039.com
                </a>
              </div>
              <div className="mt-6">
                <p className="text-sm font-semibold mb-2 text-white/80">服务中心地址</p>
                <p className="text-neutral-300 text-sm leading-relaxed">
                  广州市白云区白云大道南<br />
                  天健广场1039服务中心
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 底部信息栏 */}
        <div className="pt-8 border-t border-white/10 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-accent transition-all duration-300 cursor-pointer">
              <i className="ri-wechat-fill text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-accent transition-all duration-300 cursor-pointer">
              <i className="ri-weibo-fill text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-accent transition-all duration-300 cursor-pointer">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
          </div>

          <div className="text-neutral-400 text-sm">
            © 2025 白云天健1039市采易. 保留所有权利
          </div>

          <div className="flex items-center gap-6">
            <a href="#" className="text-neutral-400 hover:text-white transition-colors underline text-sm cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-neutral-400 hover:text-white transition-colors underline text-sm cursor-pointer">
              使用条款
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-neutral-400 hover:text-white transition-colors underline text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
